export const GRAPH_API_PROFILE = process.env.REACT_APP_GRAPH_API_PROFILE
export const GRAPH_API_PREDICTIONS = process.env.REACT_APP_GRAPH_API_PREDICTIONS
export const GRAPH_WS_PREDICTIONS = process.env.REACT_APP_GRAPH_WS_PREDICTIONS
export const GRAPH_API_PREDICTION = process.env.REACT_APP_GRAPH_API_PREDICTION

